"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ModalRedirectPaymentContent = ({ text = '' }) => {
    const termsContentText = text ||
        `Ao clicar em Ok você será redirecionado a página do seu banco para finalizar o pagamento, assim que for finalizado e validado a sua reserva será efetuada. Agradecemos a preferência ❤`;
    return (react_1.default.createElement("div", { className: "terms-modal-body" },
        react_1.default.createElement("div", { className: "terms-data-container" }, termsContentText)));
};
exports.default = ModalRedirectPaymentContent;
